
  var _styles = {
  "deal-double": {
    "display": "flex",
    "alignItems": "center"
  },
  "deal-double-card": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  },
  "deal-double-id": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.45333rem",
    "fontWeight": "400"
  },
  "deal-single": {
    "display": "flex",
    "alignItems": "center"
  },
  "deal-single-card": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  },
  "deal-horizontal": {
    "paddingLeft": "0.16rem"
  }
};



  module.exports = _styles;
  